import * as React from "react";
import { PaneHeader } from "../../../shared/components/pane";
import { useLang } from "../../../shared/i18n/LangContext";

interface AppProps {
  title: string;
}

/**
 * Standaard-taskpane (SourceLocation in het manifest). Besluit Asil 4 oktober 2026 (13A): geen welkomstpagina
 * meer met algemene teksten en geen licentiecontrole; alleen een verwijzing naar het lint, waar alle panes staan.
 * De pane heeft geen taalkeuze en volgt de taal van Excel (Store-voorbereiding, 5 oktober 2026).
 */
const App: React.FC<AppProps> = (props: AppProps) => {
  const lang = useLang();
  return (
    <div className="taskpane-root">
      <PaneHeader
        title={props.title || "SmartSuite"}
        className="taskpane-header"
        watermark={false}
      />
      <p className="taskpane-line">
        {lang === "EN"
          ? "Use the AGTT tab on the ribbon."
          : "Gebruik het tabblad AGTT in het lint."}
      </p>
    </div>
  );
};

export default App;
